export const QUICK_MODEL_TYPE_LIST: CF.API.Models.ModelTypesEntity[] = [
  {
    id: 'llm',
    title: 'Large Language Models',
    description:
      'Narrow down your view to only include large language AI models. These models serve as the base upon which more complex algorithms and computations are built. Ideal for those who are looking for well-established, reliable models that have been widely accepted and used within the AI community.',
    trainable: true,
    creatable: true,
    model_type_fields: [],
    evaluation_type: 1,
    expected_input_layers: [],
    expected_output_layers: [],
  },
  {
    id: 'text-to-image',
    title: 'Image Generation Models',
    description:
      'Filter models that produce distinct images based on the provided prompts, such as Stable Diffusion and Dall-E. The output can range from abstract artistic creations to stunningly realistic images.',
    trainable: true,
    creatable: true,
    model_type_fields: [],
    evaluation_type: 1,
    input_fields: ['text'],
    output_fields: ['image'],
    expected_input_layers: [],
    expected_output_layers: [],
  },
  {
    id: 'multimodal-to-text',
    title: 'Multimodal To Text',
    description: 'Generate text from either text or images or both as input, allowing it to understand and respond to questions about those images',
    input_fields: ['any'],
    output_fields: ['text'],
    trainable: true,
    creatable: true,
    model_type_fields: [],
    evaluation_type: 1,
    expected_input_layers: [],
    expected_output_layers: [],
  },
  {
    id: 'multimodal-embedder',
    title: 'Multimodal Embedder',
    description:
      'Embed text or image into a vector representing a high level understanding from our AI models, e.g. CLIP. These embeddings enable similarity search and training on top of them.',
    input_fields: ['any'],
    output_fields: ['embeddings'],
    trainable: true,
    creatable: true,
    model_type_fields: [],
    evaluation_type: 1,
    expected_input_layers: [],
    expected_output_layers: [],
  },
  {
    id: 'text-to-audio',
    title: 'Text To Audio',
    description: 'Given text input, this model produces an audio file containing the spoken version of the input.',
    input_fields: ['text'],
    output_fields: ['audio'],
    model_type_fields: [],
    evaluation_type: 1,
    expected_input_layers: [],
    expected_output_layers: [],
  },
];

export const FILTER_OPTION_BY_FIELD: Record<string, Array<{ label: string; value: string }>> = {
  use_cases: [
    {
      value: 'llm',
      label: 'Large Language Models',
    },
  ],
  model_type_id: [
    {
      value: 'text-to-image',
      label: 'Image Generation Models',
    },
    {
      value: 'multimodal-to-text',
      label: 'Multimodal To Text',
    },
    {
      value: 'multimodal-embedder',
      label: 'Multimodal Embedder',
    },
    {
      value: 'text-to-audio',
      label: 'Text To Audio',
    },
  ],
};

export const isQuickFilters = (type: string, value: string) => {
  return FILTER_OPTION_BY_FIELD[type]?.find((filter) => filter.value === value);
};

export const QUICK_MODEL_FIELDS: Array<string> = Object.keys(FILTER_OPTION_BY_FIELD ?? {});
